import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { CloudProvider } from "@/context/CloudContext";
import Shell from "@/components/Shell";
import LoginPage from "@/pages/LoginPage";
import DashboardPage from "@/pages/DashboardPage";
import LedgerPage from "@/pages/LedgerPage";
import ProjectPage from "@/pages/ProjectPage";
import ArchivedPage from "@/pages/ArchivedPage";
import SettingsPage from "@/pages/SettingsPage";
import SearchPage from "@/pages/SearchPage";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null) return <div data-testid="app-loading" className="flex min-h-screen items-center justify-center bg-[#f4f3f2] text-sm text-gray-500">Loading…</div>;
  if (user === false) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  return (
    <CloudProvider>
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-right" richColors />
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route element={<Protected><Shell /></Protected>}>
              <Route path="/" element={<DashboardPage />} />
              <Route path="/ssh" element={<LedgerPage key="SSH" type="SSH" />} />
              <Route path="/mmc" element={<LedgerPage key="MMC" type="MMC" />} />
              <Route path="/projects/:id" element={<ProjectPage />} />
              <Route path="/archived" element={<ArchivedPage />} />
              <Route path="/settings" element={<SettingsPage />} />
              <Route path="/search" element={<SearchPage />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </CloudProvider>
  );
}

export default App;
